var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.overridesAvailable
    ? _c(
        "div",
        [
          _c("SectionHeader", {
            attrs: {
              "show-content": _vm.bidDurationSettingsShowContents,
              "widget-title": _vm.$t("HEADER_BID_DURATION_SETTINGS")
            },
            on: {
              onShowContentsClick: function($event) {
                return _vm.onBidDurationSettingsShowContentsClick()
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "form-horizontal",
                          attrs: { role: "form", name: "bidDurationSettings" }
                        },
                        [
                          _c("Field", {
                            attrs: {
                              label: _vm.$t("LABEL_BID_GOOD_FOR"),
                              "hide-label": false,
                              "has-tooltip": true,
                              "tooltip-text": _vm.$t("TOOLTIP_BID_GOOD_FOR")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "element",
                                  fn: function() {
                                    return [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: _vm.bidExpirationRule,
                                          slim: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({
                                                classes,
                                                errors
                                              }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "p-l-0 col-sm-5 col-md-1"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "form-control",
                                                        class: classes,
                                                        attrs: {
                                                          name:
                                                            "bidExpirationInSeconds",
                                                          "data-cy":
                                                            "bidExpirationInSeconds",
                                                          disabled:
                                                            _vm.affiliateView,
                                                          placeholder: _vm.$t(
                                                            "LABEL_PLACEHOLDER_BID_GOOD_FOR"
                                                          ),
                                                          type: "number"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.bidExpirationInSeconds
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.onBidGoodForOnInput,
                                                          change:
                                                            _vm.onBidGoodForOnChange,
                                                          wheel: function(
                                                            $event
                                                          ) {
                                                            return $event.target.blur()
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    { staticClass: "m-t-10" },
                                                    [_vm._v("seconds")]
                                                  ),
                                                  _vm._v(" "),
                                                  errors[0]
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-group__label-required vv-invalid",
                                                          attrs: {
                                                            name:
                                                              "bidExpirationInSeconds-invalid-label",
                                                            "data-cy":
                                                              "bidExpirationInSeconds-invalid-label"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.bidExpirationValidationError
                                                            ) +
                                                              "\n              "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-group__label-required p-l-10"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("REQUIRED")
                                                            ) +
                                                              "\n              "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2209774006
                                        )
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              448386106
                            )
                          }),
                          _vm._v(" "),
                          !_vm.affiliateView
                            ? _c("Field", {
                                attrs: {
                                  label: _vm.$t(
                                    "LABEL_ROUTE_CALLS_FOR_STALE_BIDS"
                                  ),
                                  "hide-label": false,
                                  "has-tooltip": true,
                                  "tooltip-text": _vm.$t(
                                    "TOOLTIP_ROUTE_CALLS_FOR_STALE_BIDS"
                                  )
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "element",
                                      fn: function() {
                                        return [
                                          _c(
                                            "ValidationProvider",
                                            {
                                              attrs: {
                                                rules: "required",
                                                slim: ""
                                              }
                                            },
                                            [
                                              _c("MultipleToggle", {
                                                attrs: {
                                                  value:
                                                    _vm.routeCallsForStaleBids,
                                                  options:
                                                    _vm.routeCallsForStaleBidsOptions,
                                                  disabled: _vm.affiliateView
                                                },
                                                on: {
                                                  onToggle:
                                                    _vm.onRouteCallsForStaleBidsChange
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  2293304505
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              961545396
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }